<template>
<div>
  <div v-if="!id">
    <AlertPop/>
  </div>
  <div class="limiter" v-if="id">
    <div class="image">
      <img src="../assets/logo/logo.png" alt="Logo">
    </div>
    <div class="container-login100">
      <div class="wrap-login100">
        <form class="login100-form validate-form" @submit.prevent="submitPin">
          <h1 class="card-title mb-3 text-dark text-uppercase" style="font-weight:700"><span
              style="color: #3A6898">Log</span> In</h1>
          <div class="form-floating mb-3 w-100">
            <input class="form-control" :type="passwordFieldType" v-model="pin" id="floatingInput" required>
            <label for="floatingInput">Password</label>
          </div>
          <p v-if="errorMessage" class="text-danger small mt-2" role="alert" data-testid="login-error">
            {{ errorMessage }}
          </p>
          <div class="form-group">
            <label class="show-password-checkbox float-start" style="cursor: pointer">
              <input type="checkbox" v-model="show_password">
              Show Password
            </label>
          </div>
          <button type="submit" class="login100-form-btn">
            Login
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import AlertPop from "@/components/AlertPop.vue";

export default {
  computed: {
    passwordFieldType() {
      return this.show_password ? 'text' : 'password';
    },
  },
  data() {
    return {
      show_password: false,
      pin: '',
      id: this.$route.query.id,
      username: '',
      userDetails: '',
      type:'',
      price:'',
      state:'',
      errorMessage: '',
      errorHttpStatus: null,
    };
  },
  watch: {
    '$route.query.id': function(newId) {
      this.id = newId;
    },
  },
  components:{
    AlertPop
  },
  methods: {
    async submitPin() {
      // Clear any previous error so a new attempt doesn't show stale text.
      this.errorMessage = '';
      this.errorHttpStatus = null;
      const payload = {
        dispatchid: this.id,
        pin: this.pin,
      }
      this.$store.commit('setLoadingState', true);
      return await this.$store.dispatch('login', payload)
          .then((response) => {
            this.userDetails = response;
            this.username = this.userDetails.username;
            this.type = this.userDetails.type;
            this.state = this.userDetails.userType;
            this.headerId = this.userDetails.headerId;
            this.status = this.userDetails.status;
            this.price = this.userDetails.courierPrice;
            this.priceType = this.userDetails.priceType;

            this.redirectBasedOnState(this.state,this.status);
          })
          .catch((err) => {
            // The login action re-throws with .message = friendlyMessage
            // and .httpStatus / .rawMessage attached.
            this.errorMessage = err && err.message ? err.message : 'An unexpected error occurred.';
            this.errorHttpStatus = err && err.httpStatus != null ? err.httpStatus : null;
            if (window.Toast) {
              window.Toast.fire({ icon: 'error', title: this.errorMessage, timer: 3000 });
            }
          })
          .finally(()=> this.$store.commit('setLoadingState', false))
    },

    redirectBasedOnState(state,status) {
      switch (state) {
        case 'Staff':
          this.$router.push({ name: 'Dispatch', query: { id: this.id, userName: this.username, type: this.type, Delivered : this.status } });
          break;
        case 'Courier':
          if (status === "Courier"){
            return this.$router.push({ name: 'ShowStock', query: { id: this.id, type: this.type, userName: this.username,headerId : this.headerId } });
          }
          return this.$router.push({ name: 'Courier', query: { id: this.id, price: this.price, priceType: this.priceType, type: this.type, userName: this.username, } });
          break;
        default:
          console.error('Unknown state:', state);
          break;
      }
    }
  }
};
</script>

<style scoped>
/* Add your styles here */
</style>
